import { render, staticRenderFns } from "./EditFormLecture.vue?vue&type=template&id=38610c82&"
import script from "./EditFormLecture.vue?vue&type=script&lang=js&"
export * from "./EditFormLecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports